
(function(){
  'use strict';
  var NS='http://www.w3.org/2000/svg';
  var BORSA=['M19.33 7H23v11a5 5 0 0 1-5 5H6a5 5 0 0 1-5-5V7',
             'M0 7h14a3 3 0 0 0 3-3a3 3 0 0 0-3-3h-4a3 3 0 0 0-3 3v3'];
  var PERSONE=['M9 3a3 3 0 1 1 0 6a3 3 0 0 1 0-6','M3 20v-2a6 6 0 0 1 12 0v2','M16 3a3 3 0 0 1 0 6','M17 12a5 5 0 0 1 4 5v3'];
  var RESO=['M6 4H18L19.5 9.5H4.5Z',
            'M4.5 9.5V19',
            'M7.11 19H18.1A1.4 1.4 0 0 0 19.5 17.6V9.5',
            'M12 4V12.07',
            'M9.39 16.72L7.11 19L9.39 21.28'];
  var CESTINO=['M3.35 7H15.46V3.38H9.5',
               'M17.57 7H21.4',
               'M6.42 7V18.4A1.6 1.6 0 0 1 8.02 20H16.74A1.6 1.6 0 0 1 18.34 18.4V7',
               'M10.26 9.42V17.6',
               'M14.5 9.42V17.6'];
  function disegna(svg,tracciati,punte,spigoli){
    if(!svg||svg.getAttribute('data-psi-icon')==='1'){return;}
    while(svg.firstChild){svg.removeChild(svg.firstChild);}
    svg.setAttribute('viewBox','0 0 24 24');
    svg.setAttribute('fill','none');
    svg.setAttribute('stroke','currentColor');
    svg.setAttribute('stroke-linecap',punte);
    svg.setAttribute('stroke-linejoin',spigoli);
    for(var i=0;i<tracciati.length;i++){
      var p=document.createElementNS(NS,'path');
      p.setAttribute('d',tracciati[i]);
      svg.appendChild(p);
    }
    svg.setAttribute('data-psi-icon','1');
  }
  function perPrefisso(prefisso,tracciati,punte,spigoli){
    var n=document.querySelectorAll('path[d^="'+prefisso+'"]'),i;
    for(i=0;i<n.length;i++){
      var s=n[i].parentNode;
      if(s&&s.tagName&&s.tagName.toLowerCase()==='svg'){disegna(s,tracciati,punte,spigoli);}
    }
  }
  function applica(){
    var i;
    var nav=document.getElementById('psi-mnav');
    if(nav){
      var voci=nav.querySelectorAll('a.psi-mnav-service');
      for(i=0;i<voci.length;i++){
        var href=voci[i].getAttribute('href')||'';
        var s=voci[i].querySelector('svg');
        if(!s){continue;}
        if(/\/cart(\?|$|#)/.test(href)){disegna(s,BORSA,'butt','miter');}
        else if(/chi-siamo/.test(href)){disegna(s,PERSONE,'round','round');}
        else if(/\/pages\/resi/.test(href)){disegna(s,RESO,'round','round');}
      }
    }
    var res=document.querySelectorAll('.psi-cart-returns-icon');
    for(i=0;i<res.length;i++){disegna(res[i],RESO,'round','round');}
    perPrefisso('M3 12a9 9',RESO,'round','round');
    perPrefisso('M4 9h11a5 5',RESO,'round','round');
    perPrefisso('M4 7h16',CESTINO,'butt','round');
  }
  var inCoda=false;
  function programma(){
    if(inCoda){return;}
    inCoda=true;
    (window.requestAnimationFrame||window.setTimeout)(function(){inCoda=false;applica();},16);
  }
  applica();
  if(window.MutationObserver){
    try{
      new MutationObserver(programma).observe(document.body,{childList:true,subtree:true});
    }catch(e){}
  }
  document.addEventListener('DOMContentLoaded',applica);
  window.addEventListener('load',applica);
}());
